<script setup>
// The trang kieu Pancake, dung o ca ba cho: luoi trang chinh, modal Ket noi,
// modal Gop trang. Chi khac nhau o cho co dau tick hay co nut thao tac.
import Avatar from 'dashboard/components-next/avatar/Avatar.vue';
import { usePancakeMetrics } from 'dashboard/composables/usePancakeMetrics';
import { pageIdentifier, platformIcon } from './platforms';

defineProps({
  inbox: { type: Object, required: true },
  selectable: { type: Boolean, default: false },
  selected: { type: Boolean, default: false },
  // Card chi de xem, khong bam duoc (danh sach trang da noi trong modal Ket noi).
  readonly: { type: Boolean, default: false },
});

defineEmits(['click']);

const { cardAvatarSize } = usePancakeMetrics();
</script>

<template>
  <div
    class="flex items-center w-full gap-2 border rounded-xl transition-colors"
    :class="[
      selectable ? '' : 'pe-3',
      selected
        ? 'bg-[rgb(var(--pk-hang-chon))] border-[rgb(var(--pk-tab-active))]'
        : 'border-[rgb(var(--pk-vien))] bg-n-background',
    ]"
  >
    <!-- Bong bong tren CA the chu khong rieng dong ten: ten bi `truncate` cat
         nen phai ro chuot vao dau cung doc duoc, nhat la trong modal gop trang
         khi phai chon nhanh giua nhieu trang ten na na nhau.
         `container: false` de bong bong nam ngay trong the. Mac dinh no gan
         vao <body>, ma modal la <dialog> showModal() nen o top layer — bong
         bong van co that trong DOM nhung bi modal ve de len, nhin nhu mat. -->
    <component
      :is="readonly ? 'div' : 'button'"
      v-tooltip.top="{
        content: inbox.name,
        popperClass: 'bonboz-bang-the',
        container: false,
      }"
      :type="readonly ? undefined : 'button'"
      class="flex items-center flex-1 min-w-0 gap-3 p-3 text-start rounded-xl"
      :aria-pressed="selectable ? selected : undefined"
      @click="!readonly && $emit('click', inbox)"
    >
      <Avatar
        :src="inbox.avatar_url"
        :name="inbox.name"
        :size="cardAvatarSize"
        class="shrink-0"
      />
      <div class="min-w-0">
        <div class="text-sm font-medium truncate text-n-slate-12">
          {{ inbox.name }}
        </div>
        <div class="flex items-center gap-1.5 mt-0.5 text-xs text-n-slate-11">
          <span :class="platformIcon(inbox)" class="size-3.5 shrink-0" />
          <span class="truncate">{{ pageIdentifier(inbox) }}</span>
        </div>
      </div>
      <!-- Dau tick trong nut: ca the la vung bam, de ngoai thi bam vao vong
           tron khong an gi. -->
      <span
        v-if="selectable"
        class="flex items-center justify-center ms-auto rounded-full size-5 shrink-0"
        :class="
          selected
            ? 'bg-[rgb(var(--pk-tab-active))] text-white'
            : 'border border-[rgb(var(--pk-vien))]'
        "
      >
        <span v-if="selected" class="i-lucide-check size-3.5" />
      </span>
    </component>
    <div v-if="!selectable" class="flex items-center gap-1 shrink-0">
      <slot name="actions" />
    </div>
  </div>
</template>
